import { Button } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { ProfileEvent } from '@flipster/utils/segment/events/profile';

import { SegmentPage } from '../../misc/segment/segment-page';

const MakePublicLabel = 'Make both public to add links';

interface PublicAgreementProps {
  onClose: () => void;
  onPrimary: () => void;
  onSecondary: () => void;
  secondaryLabel: string;
}
const PublicAgreement = ({ onClose, onPrimary, onSecondary, secondaryLabel }: PublicAgreementProps) => {
  return (
    <>
      <SegmentPage name='switch_public_modal_view' />
      <Modal.Close onClose={onClose} />
      <Modal.Header>
        <Modal.Title label='Set both to public to add social links' />
      </Modal.Header>
      <Modal.Content>
        <section className={css({ whiteSpace: 'pre-wrap' })}>
          {
            'To add social links, both performance and trading activity must be set to public.\n\nSwitching to public makes your performance and trading activity visible as well. You can always go back to private anytime.'
          }
        </section>
      </Modal.Content>
      <Modal.Footer>
        <div className={stack({ gap: 8, w: { base: 328, tabletDown: '100%' } })}>
          <Button
            size='large'
            label='Make both public to add links'
            withSpinner
            onClick={() => {
              segment.track(ProfileEvent.SwitchPublicButtonClick, {
                button_text: MakePublicLabel,
              });
              return onPrimary();
            }}
          />
          <Button
            hierarchy='secondary'
            size='large'
            color='neutral'
            label={secondaryLabel}
            withSpinner
            onClick={() => {
              segment.track(ProfileEvent.SwitchPublicButtonClick, {
                button_text: secondaryLabel,
              });
              return onSecondary();
            }}
          />
        </div>
      </Modal.Footer>
    </>
  );
};

export default PublicAgreement;
